module.exports = "/assets/387ebf6bce468d0cef3570c13999f06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3H.png
// module id = 1008
// module chunks = 0